import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";

export type RegistrationStage = {
    id: number;
    eventId: number;
    startDate: string;
    endDate: string;
    totalDays: number;
    numberOfStage: number;
};

export type AddRegistrationStageRequest = {
    /**
     * Duration in seconds.
     */
    duration: number;
};

export type RegistrationChangesAfterDueDateStatus = "allowed" | "allowedForSingleCompetitorCategories" | "notAllowed";

export type RegistrationStagesOptions = {
    eventId: number;
    allowEditRegistrationsAfterDueDate: boolean;
    allowEditRegistrationsAfterDueDateUntil: string | null;
    allowChangesOnlyInSingleCompetitorCategories: boolean;
};

export default {
    saveRegistrationStagesOptions(request: RegistrationStagesOptions) {
        return promiseRequest({
            url: `/api/admin/events/${request.eventId}/registration-stages/actions/save-options`,
            method: "put",
            json: request,
        }).then(resolveNoContent());
    },
    getOptions(eventId: number): Promise<RegistrationStagesOptions> {
        return promiseRequest<RegistrationStagesOptions>({
            url: `/api/admin/events/${eventId}/registration-stages/options`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    getAll(eventId: number): Promise<Array<RegistrationStage>> {
        return promiseRequest<Array<RegistrationStage>>({
            url: `/api/admin/events/${eventId}/registration-stages`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },
    addAnotherRegistrationStage(eventId: number, request: AddRegistrationStageRequest) {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/registration-stages`,
            method: "post",
            json: request,
        }).then(resolveNoContent());
    },
    removeRegistrationStage(eventId: number, registrationStageId: number) {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/registration-stages/${registrationStageId}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
    editRegistrationStage(id: number, eventId: number, startDate: string, endDate: string) {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/registration-stages/${id}`,
            method: "put",
            json: {
                id: id,
                eventId: eventId,
                startDate: startDate,
                endDate: endDate,
            },
        }).then(resolveNoContent());
    },
};
